import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {map, Observable} from 'rxjs';
import {GeoLocation} from '../../model/geo-location';
import {Risks} from '../../model/risks';

@Injectable({
  providedIn: 'root'
})
export class RiskLocationService {
  constructor(private readonly http: HttpClient) {
  }

  getGeoLocationByAddress(address: string): Observable<GeoLocation> {
    return this.http.get(environment.backend + '/v1/proposals/geo_location/' + address)
      .pipe(map((gl: any) => {
        if (gl !== null) {
          return new GeoLocation({lat: gl.results[0]?.geometry.location.lat, lng: gl.results[0]?.geometry.location.lng});
        } else {
          return null;
        }
      }));
  }

  submitGeoLocationToKIS(geoLocation: GeoLocation): Observable<Risks> {
    return this.http.get<Risks>(environment.backend + '/v1/proposals/kis_service', {params: new HttpParams().set('lat', geoLocation.lat).set('lng', geoLocation.lng)})
      .pipe(map(risks => new Risks(risks)));
  }
}
